import { appstore, googleplay } from '@/utils/imagepath';
import React from 'react';
import { useSelector } from 'react-redux';

const MobileAppSection = ({ themeData }: any) => {
  const settingsData: any = useSelector<any>((state) => state?.settings);

  return (
    <>
      {' '}
      <section className="mobapp-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="mobapp-content">
                <div className="section-title text-start">
                  <h2
                    className="ps-0"
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_11?.h2color}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_11?.title}
                  </h2>
                  <p
                    className="ps-0"
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_11?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_11?.paragraph}
                  </p>
                </div>
                <ul className="app-highlights">
                  {themeData?.theme_4?.home?.section_11?.check_list?.map(
                    (val: any) => {
                      return (
                        <>
                          <li key={val?.id}>
                            <div className="d-flex align-items-center">
                              <span className="flex-shrink-0 icon-box">
                                <img src={val?.icons} alt="" />
                              </span>
                              <div className="flex-grow-1">
                                <h5
                                  className="ps-0"
                                  style={{
                                    color: `#${themeData?.theme_4?.home?.section_11?.h3color}`,
                                  }}
                                >
                                  {val?.title}
                                </h5>
                              </div>
                            </div>
                          </li>
                        </>
                      );
                    }
                  )}
                </ul>
                <ul className="applinks">
                  {settingsData != null &&
                    Object.keys(settingsData).length > 0 &&
                    settingsData?.WebmasterSettings?.app_store_link !== '' && (
                      <li>
                        <a
                          target="_blank"
                          href={settingsData?.WebmasterSettings?.app_store_link}
                        >
                          <img src={appstore} alt="" />
                        </a>
                      </li>
                    )}

                  {/* <li>
                                    <a className='qrbox'><img src={qrcode} alt=""/></a>
                                </li> */}
                  {settingsData != null &&
                    Object.keys(settingsData).length > 0 &&
                    settingsData?.WebmasterSettings?.play_store_link !== '' && (
                      <li>
                        <a
                          target="_blank"
                          href={
                            settingsData?.WebmasterSettings?.play_store_link
                          }
                        >
                          <img src={googleplay} alt="" />
                        </a>
                      </li>
                    )}
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mobapp-img text-center">
                <img
                  src={themeData?.theme_4?.home?.section_11?.banner}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileAppSection;
